<template>
    <div class="container">
        <!-- <nav-bar title="签约"></nav-bar> -->
        <div class="line1">
            <div class="L1">
                <label class="label1">首次使用手机银行收银台支付前，请您先完成签约</label>
            </div>
        </div>
        <div class="line1">
            <div class="showline">
                <ui-field>
                    <ui-input-item
                        name="username"
                        type="text"
                        title="姓名"
                        placeholder="请输入姓名"
                        align="right"
                        v-model.trim="username"
                        maxlength="18"></ui-input-item>
                </ui-field>
            </div>
            <div class="showline">
                <ui-field>
                    <ui-input-item
                        name="idNO"
                        type="text"
                        title="身份证号码"
                        placeholder="请输入身份证号码"
                        align="right"
                        v-model.trim="idNo"
                        maxlength="18"></ui-input-item>
                </ui-field>
            </div>
            <div class="L1 showline">
                <label>手机号码</label>
                <span>{{payInfo.userMobile | phoneNumFilter}}</span>
            </div>
            <div class="captch-item">
                <ui-input-item
                    name="captcha"
                    type="text"
                    title="短信验证码"
                    placeholder="请输入验证码"
                    align="right"
                    v-model.trim="captcha"
                    maxlength="6"></ui-input-item>
                <span v-show="isSendCaptcha" class="getCaptcha" @click="onCaptcha">获取验证码</span>
                <span v-show="!isSendCaptcha" class="getCaptcha" style="color: #848996">已发送{{sendCount}}s</span>
            </div>
        </div>
        <div class="line1 proFont">
            <ui-agree
                v-model="agreeConfig.checked"
                :disabled="agreeConfig.disabled"
                :size="agreeConfig.size">
                <p>
                    我已认真阅读并同意
                    <span @click="goProtocol">《绍兴银行股份有限公司手机银行支付协议》</span>
                </p>
            </ui-agree>
        </div>
        <ui-button class="btn-blue" @click="toSign">签约</ui-button>
    </div>
</template>

<script>
// import NavBar from '@/components/NavBar';
import {validatePhone,validateIdCard,validateCaptcha} from '../../plugins/validate';
import { toMap, mapToString, sortMapKeys} from '@/modules/utils/stringToMap'
import { encryptLong, decryptLong} from '../../modules/utils/jsencrypt'
import {mapState, mapActions} from 'vuex'
export default {
    // components:{
    //     NavBar
    // },
    data(){
        return{
            username:"",
            idNo:"",
            captcha:'',
            isSendCaptcha:true,  //是否点击发送验证码
            sendCount:60, //验证码倒计时
            timer:"",
            agreeConfig:{
                checked:false,  //勾选的状态
                name:"protocol",
                size:"md",
                disabled:false,
                introduction:"选中状态"
            },
            merchantDateTime:"",  //交易时间
            payInfo:{},
            accList:{}, //卡列表
            smsType:"",
            successUrl:"", //成功回调地址
            orderData:"",  //接收酷屏通过URL传过来的数据
            count:0,
        }
    },
    methods: {
        _validdateName(val){
            // let _resMsg = /^[\u4E00-\u9FA5][\u4E00-\u9FA5|·]*[\u4E00-\u9FA5]$/.test(val);
            let _resMsg = /^[\u4E00-\u9FA5\uf900-\ufa2d・·•（）()s]{2,18}$/.test(val);
            if(!val){
                return "请输入姓名"
            }
            if(!_resMsg){
                return "您输入的姓名格式不正确"
            }
        },
        // 点击发送验证码
        onCaptcha(){
            this.count = this.count + 1;
            this.sendCountTime();
            this.merchantDateTime = this.getTime()
            let reqHead = {
                TransMerSeqNo:this.payInfo.transSeqNo,
                MerchantDateTime:this.merchantDateTime,
                MerchantId:this.payInfo.merchantId,
                DevId:this.payInfo.deviceNum,
                ChannelId:"EKP",
                UserId:this.payInfo.merUserId,
                Version:"V1.0",
                TransId:"CreateMessageCode",
            }
            let reqBody = {
                mobile:this.payInfo.userMobile,
                SmsTransId:"PaySign"
            }
            let params = {
                ReqHead:reqHead,
                ReqBody:reqBody
            }
            console.log(params)
            // this.$api.post("/sxyh",params).then(res => {
            //     if(res.ResHead.SysRtnCd !== "00000000"){
            //         this.$dialog.alert({
            //             title:"温馨提示",
            //             content:res.ResHead.SysRtnDesc
            //         });
            //         this.sendCount = 60;
            //         this.isSendCaptcha = true;
            //         clearInterval(this.timer);
            //     }
            // })
        },
        // 60s倒计时
        sendCountTime(){
            this.isSendCaptcha = false;
            let _this = this;
            this.timer = setInterval(function() {
                if(_this.sendCount !== 0){
                    _this.sendCount -= 1;
                } else {
                    _this.sendCount = 60;
                    _this.isSendCaptcha = true;
                    clearInterval(_this.timer);
                }
            }, 1000);
        },
        goProtocol(){
            this.$store.state.agreeFlag = this.agreeConfig.checked;
            this.$store.state.routerFlag = true
            this.$router.replace('/agreement');
        },
        //点击签约
        toSign(){
            this.username.replace(/\ +/g,"");
            //校验姓名
            let validdNameRes = this._validdateName(this.username);
            if(validdNameRes != undefined){
                this.$dialog.alert({
                    title:"温馨提示",
                    content:validdNameRes
                })
                return;
            }
            //校验身份证号码
            let validIdCardRes = validateIdCard(this.idNo);
            if(validIdCardRes != undefined){
                this.$dialog.alert({
                    title:"温馨提示",
                    content:validIdCardRes
                })
                return;
            }
            //是否点击获取验证码
            if(this.count == 0){
                this.$dialog.alert({
                    title:"温馨提示",
                    content:"请获取验证码"
                })
                return;
            }
            //校验验证码
            let validCaptchaRes = validateCaptcha(this.captcha);
            if(validCaptchaRes != undefined){
                this.$dialog.alert({
                    title:"温馨提示",
                    content:validCaptchaRes
                })
                return;
            }
            //勾选协议
            if(!this.agreeConfig.checked){
                this.$dialog.alert({
                    title:"温馨提示",
                    content:"请勾选协议"
                })
                return;
            }
            this.sign();
        },
        //签约
        sign(){
            this.merchantDateTime = this.getTime();
            let reqHead = {
                TransMerSeqNo:this.payInfo.transSeqNo,
                MerchantDateTime:this.merchantDateTime,
                MerchantId:this.payInfo.merchantId,
                DevId:this.payInfo.deviceNum,
                ChannelId:"EKP",
                UserId:this.payInfo.merUserId,
                Version:"V1.0",
                TransId:"PaySign",
            }
            let reqBody = {
                UserName:this.username,
                UserCertType:"B",
                UserCertNo:this.idNo,
                UserMobile:this.payInfo.userMobile,
                _pTokenName:this.captcha,
                SendType:"1",
                SignType:"0",
                EventCode:"000"
            }
            let params = {
                ReqHead:reqHead,
                ReqBody:reqBody
            }
            console.log(params);
            this.$api.post("/sxyh",params).then(res => {
                if(res.ResHead.SysRtnCd == "00000000"){
                    this.$router.replace("/pay")
                }else{
                    this.$dialog.alert({
                        title:"温馨提示",
                        content:res.ResHead.SysRtnDesc
                    })
                }
            })
        },
        //获取当前时间
        getTime(){
            var myDate = new Date();
            var time = myDate.getFullYear().toString() + this.pad2(myDate.getMonth() +1) + this.pad2(myDate.getDate()) + this.pad2(myDate.getHours()) + this.pad2(myDate.getMinutes()) + this.pad2(myDate.getSeconds());
            return time;
        },
        //月份前加0
        pad2(n){
            return n < 10 ? '0' + n : n;
        },
        // payOrderQuery(val){
        //     let reqHead = {
        //         orderNo:val,
        //         TransId:"QueryIpayOrder",
        //     }
        //     let reqBody = {}
        //     let params = {
        //         ReqHead:reqHead,
        //         ReqBody:reqBody
        //     }
        //     console.log(params)
        //     this.$api.post("/sxyh",params).then(res => {
        //         if(res.ResHead.SysRtnCd == "00000000"){
        //             this.payInfo = res.ResBody.OrderEntity,
        //             this.$store.state.payInfo = res.ResBody.OrderEntity,
        //             this.$store.state.smsType = res.ResBody.SmsType,
        //             this.$store.state.successUrl = res.ResBody.DetailUrl,
        //             this.$store.state.accList =  res.ResBody.AccList,
        //             this.$store.state.orderNo = res.ResBody.OrderNo
        //             //1 未签约  0 已签约
        //             if(res.ResBody.PaySignType == "0"){
        //                 this.count = 0;
        //                 this.$router.replace("/pay")
        //             }
        //         }else{
        //             this.$dialog.alert({
        //                 title:"温馨提示",
        //                 content:res.ResHead.SysRtnDesc
        //             })
        //         }
        //     })
        // }
    },
    // created () {
    //     // this.orderData = this.$route.query.data;
    //     // this.payOrderQuery(this.orderData);
    // },
    activated(){
        this.payInfo = this.$store.state.payInfo;
        this.agreeConfig.checked = this.$store.state.agreeFlag;
    }
}
</script>

<style scoped>
    .container{
        background-color: #efeff4;
    }
    .line1{
        width:96%;
        background: #fff;
        margin:20px auto;
    }
    .line1 .L1{
        height: 90px;
        line-height: 90px;
        text-align: left;
        padding: 0 30px;
        overflow: hidden;
    }
    .line1 .L1 label{
        width: 40%;
        font-size: 28px;
    }
    .line1 .L1 span{
        /* display: inline-block; */
        width: 60%;
        font-size: 28px;
        text-align: right;
        position: absolute;
        right:0.3rem;
    }
    .line1 .L1 .label1{
        width: 100%;
        font-size: 28px;
    }
    .captch-item{
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
        padding: 0 30px;
    }
    .captch-item span{
        margin-left: 10px;
        font-size: 28px;
    }
    .getCaptcha{
        font-size: 28px;
        color:#00a0e8
    }
    .proFont{
        font-size: 22px;
        text-align: left;
        background-color: #efeff4;
    }
    .line1 p {
        margin: 0 !important;
    }
    .line1 p span{
        color:#00a0e8
    }
    .showline{
        border-bottom: 1px solid #ededf1;
    }
</style>



// WEBPACK FOOTER //
// src/views/sign/sign.vue